import { useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useMediaQuery, useTheme } from '@mui/material';
import { dispatchEventColumnDefinitions, mobileDispatchEventColumnDefs } from './columns';
import { GenericOverlay } from '../GenericNoRowsOverlay';
import { applyThemeGridSxOverrides } from '@/Infrastructure/Theme/AppThemeOverrides';
import { LegEventDataGridProps } from '../types';

import styles from './DataGrid.DispatchEvent.module.css';

/**
 * MUI Data Grid Pro component for showing Dispatch Events for a leg.
 */
export default function Grid({ rows, eventType }: LegEventDataGridProps) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [filterModel] = useState(
		eventType
			? {
					items: [
						{
							field: 'eventType',
							operator: 'equals',
							value: eventType
						}
					]
				}
			: undefined
	);

	return (
		<DataGridPro
			columns={isMobile ? mobileDispatchEventColumnDefs : dispatchEventColumnDefinitions}
			columnVisibilityModel={isMobile ? { eventType: false } : undefined}
			columnHeaderHeight={50}
			rowHeight={isMobile ? 100 : 50}
			rows={rows}
			getRowClassName={(props) => (props.indexRelativeToCurrentPage % 2 ? styles['alternate-row'] : '')}
			filterModel={filterModel || undefined}
			slots={{
				noRowsOverlay: () => <GenericOverlay overlayText='No Dispatch Events Found.' />
			}}
			sx={{
				...applyThemeGridSxOverrides(),
				'& .MuiDataGrid-columnHeaders': isMobile
					? {
							display: 'none'
						}
					: {}
			}}
		/>
	);
}
